import { createSearchParamsFromScratch } from '@townsquare/search-params';

import { PopularFeedResponse, Timeframe } from '../types';

export const fetchPopularFeed = (
	cloudId: string,
	timeframe: Timeframe,
	pageSize: number,
	after?: string,
): Promise<PopularFeedResponse> => {
	const params = createSearchParamsFromScratch({
		timeGranularity: timeframe,
		first: pageSize.toString(),
		...(after ? { after } : {}),
	});

	return fetch(
		`/gateway/api/ex/confluence/${cloudId}/analytics/rest/cloud/${cloudId}/feed/popular?${params.toString()}`,
	).then(res => {
		if (!res.ok) {
			throw new Error('Failed to fetch popular feed');
		}
		return res.json();
	});
};
